const Events = require('PSEvents');
const GenericUI = require('GenericUI').ui;
const PSState = require('PSState');
const SlotUI = require('SlotUI');
const GenericEngine = require('GenericEngine');

const relevantEventsMap = new Map();
relevantEventsMap.set(Events.GAME_ACTION_ANIMATION_ENDED, 'balance');
relevantEventsMap.set(Events.GAME_CLOSED, 'close');
relevantEventsMap.set(Events.SPIN_REQUEST, 'gameSpinStart');
relevantEventsMap.set(Events.ROUND_ANIMATION_ENDED, 'gameSpinEnd');
relevantEventsMap.set(Events.GAME_RULES, 'help');
relevantEventsMap.set(Events.LOAD_END, 'loadEnd');
relevantEventsMap.set(Events.ERROR_OUT_OF_MONEY, 'errorOutOfMoney');
relevantEventsMap.set(Events.CLOSE_GAME, 'close');
relevantEventsMap.set(Events.BET_CHANGED, 'betChanged');
relevantEventsMap.set(Events.ERROR_DIALOG, 'error/dialog');

const canEnableAudio = () => !(GenericEngine.isYggdrasilProvider() && !SlotUI.isSoundButtonEnabled() && SlotUI.isReplayMode());
const canDisableAudio = () => !(GenericEngine.isYggdrasilProvider() && !SlotUI.isSoundButtonEnabled() && !!document.getElementById('pc_game-history'));

export const init = () => {
    relevantEventsMap.forEach((oryxEvent, event) => {
        Events.subscribe(event, (data) => {
            if (window.PSGames.events) {
                window.PSGames.events.handler(oryxEvent, data);
            }
        });
    });

    window.PSGames.events = {};

    window.PSGames.events.registerHandler = function(handler) {
        window.PSGames.events.handler = handler;
    };

    window.PSGames.events.registerExternalHandler = function(externalHandler) {
        window.PSGames.events.externalHandler = externalHandler;
    };


    if (window.PSGames && window.PSGames.events && window.PSGames.events.registerExternalHandler) {
        window.PSGames.events.registerExternalHandler((op, data) => {
            switch (op) {
                case 'setGameBet':
                    if (data && data.betAmount) {
                        PSState.set({ betAmount: data.betAmount });
                    } else {
                        console.warn('Operator event "setGameBet": incorrect data structure');
                    }
                    break;
                case 'doGameSpin':
                    GenericUI.externalSpinRequest();
                    break;
                case 'openGameRules':
                    GenericUI.open('gameRules');
                    break;
                case 'enableAudio':
                    if (canEnableAudio()) {
                        PSState.set({ soundEnabled: true });
                    }
                    break;
                case 'disableAudio':
                    if (canDisableAudio()) {
                        PSState.set({ soundEnabled: false });
                    }
                    break;
                case 'doGameSuspend':
                    GenericUI.externalAutoplayStop();
                    break;
                case 'doGamePause':
                    GenericUI.externalForcePause();
                    break;
                case 'doGameResume':
                    GenericUI.externalForceResume();
                    break;
                case 'suspend':
                    GenericUI.externalAutoplayStop();
                    break;
                case 'stopReplay':
                    GenericUI.externalForcePause();
                    break;
                case 'startReplay':
                    GenericUI.externalForceResume();
                    break;
            }
        });
    }
}
